export const getDefaultOptions = (qty: number, firstAdded: boolean) => [
  {
    installation: true,
    wheels: false,
    tpms: true,
    added: firstAdded,
    qty,
  },
  {
    installation: true,
    wheels: false,
    tpms: false,
    added: false,
    qty,
  },
  {
    installation: true,
    wheels: true,
    tpms: true,
    added: false,
    qty,
  },
  {
    installation: true,
    wheels: true,
    tpms: false,
    added: false,
    qty,
  },
  {
    installation: false,
    wheels: false,
    tpms: false,
    added: false,
    qty,
  },
];
